(function($) {

	'use strict';

	var init = function() {
		$(window).resize(function() {
            if($(window).width() > 767) {
                $('.social-desktop').css('display','block');
                $('.social-mobile').css('display','none');
            } else {
                $('.social-desktop').css('display','none');
                $('.social-mobile').css('display','block');
            }
        }).resize();
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);